<div class="sidebar" #sidebar>
  <div class="card position-fixed ">
    <ul class="nav flex-column">
    <!--  Lab Results dropdownmenu-->
      <li class="nav-item" *ngIf="user && user.allowSearch">
        <a class="nav-link d-flex justify-content-between align-items-center" [ngClass]="{active: !isResultsSubnavCollapsed, inactive: isResultsSubnavCollapsed }" (click)="isResultsSubnavCollapsed = !isResultsSubnavCollapsed">
          <span class="material-icons-round icon pe-4">science</span><span class="flex-fill">Lab Results</span>
          <span class="material-icons-round" [ngClass]="{'d-none': !isResultsSubnavCollapsed, 'd-inline-block': isResultsSubnavCollapsed}">chevron_right</span>
          <span class="material-icons-round" [ngClass]="{'d-inline-block': !isResultsSubnavCollapsed, 'd-none': isResultsSubnavCollapsed}">expand_more</span>
        </a>
        <div [ngbCollapse]="isResultsSubnavCollapsed">
          <ul class="nav sidebar-subnav flex-column">
            <li class="nav-item">
              <a routerLink="/portal/results/search" class="small nav-link" routerLinkActive="active"  (click)="toggleOnResultsNav();">Search</a>
            </li>
            <li *ngIf="user && user.isLCAAdmin" class="nav-item">
              <a routerLink="/portal/results/global-search" class="small nav-link" routerLinkActive="active" (click)="toggleOnResultsNav();">Global Search</a>
            </li>
            <li class="nav-item">
              <a id="left-nav-save-searches" routerLink="/portal/results/saved-searches" routerLinkActive="active" class="small nav-link"   (click)="toggleOnResultsNav()">Saved Searches</a>
            </li>
            <li class="nav-item">
              <a routerLink="/portal/results/search-results" class="small nav-link" routerLinkActive="active" (click)="toggleOnResultsNav()">Search Results</a>
            </li>
          </ul>
        </div>
      </li>
      <!-- single menu -->
      <li class="nav-item" *ngFor="let navItem of mainNav">
        <a *ngIf="isShowMenu(navItem)" routerLink="{{ navItem.route }}" routerLinkActive="active" class="nav-link d-flex justify-content-between align-items-center" (click)="closeAllSubNavs()">
          <span class="material-icons-round icon">{{ navItem.iconName }}</span>
          <span class="flex-fill px-4">{{ navItem.title }}</span>
        </a>
      </li>

    <!-- Gaps in Care -->
      <li class="nav-item" *ngIf="user && user.isGapsInCareUser">
        <a  class="nav-link d-flex justify-content-between align-items-center" [ngClass]="{active: !isGICSubnavCollapsed, inactive: isGICSubnavCollapsed}" (click)="isGICSubnavCollapsed = !isGICSubnavCollapsed">
          <span class="material-icons-round icon pe-4">alternate_email</span>
          <span class="flex-fill">Gaps in Care</span>
          <span class="material-icons-round" [ngClass]="{'d-none': !isGICSubnavCollapsed,'d-inline-block': isGICSubnavCollapsed}">chevron_right</span>
          <span class="material-icons-round" [ngClass]="{'d-inline-block': !isGICSubnavCollapsed,'d-none': isGICSubnavCollapsed}">expand_more</span>
        </a>

        <div [ngbCollapse]="isGICSubnavCollapsed">
          <ul class="nav sidebar-subnav flex-column">
            <li class="nav-item">
              <a routerLink="/portal/analytic-reports/gaps-in-care/status" class="small nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleOnGICNav();">Status</a>
            </li>

            <li class="nav-item">
              <a routerLink="/portal/analytic-reports/gaps-in-care/downloads" class="small nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleOnGICNav();">Downloads</a>
            </li>

            <li class="nav-item">
              <a routerLink="/portal/analytic-reports/gaps-in-care"  routerLinkActive="active" class="small nav-link" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleOnGICNav();">Results</a>
            </li>

          </ul>
        </div>
      </li>
      
    <!-- Insight Analytics -->
    <li class="nav-item">
      <a *ngIf="user && user.isInsightAnalyticUser" routerLink="/portal/analytic-reports/insight-analytics" routerLinkActive="active" class="nav-link d-flex justify-content-between align-items-center" (click)="closeAllSubNavs()">
        <span class="material-icons-round icon">analytics</span>
        <span class="flex-fill px-4">Insight Analytics</span>
      </a>
    </li>
    </ul>
  </div>
</div>